import React from 'react'
import {
    Show,
    SimpleShowLayout,
    TextField,
    ReferenceField,
    NumberField,
} from 'react-admin'


export const ProvinciaShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <NumberField source="id" label="ID"/>
            <NumberField source="code" label="Código" />
            <TextField source="name" label="Nombre" />
            <ReferenceField source="region" reference="regiones" label="Región" >
                <TextField source="name" />
            </ReferenceField>
        </SimpleShowLayout>
    </Show>
);
